import React, { useEffect, useState } from "react";
import { fetchJobById } from "../api";
import { useParams } from "react-router-dom";

const JobDetail = () => {
    const { id } = useParams();
    const [job, setJob] = useState(null);

    useEffect(() => {
        const getJob = async () => {
            const data = await fetchJobById(id);
            setJob(data);
        };
        getJob();
    }, [id]);

    if (!job) return <p>Loading...</p>;

    const formattedDescription = job.description.split("\n").map((line, index) => (
        <p key={index}>{line}</p>
    ));

    return (
        <div className="container mt-5">
            <h1 className="text-center mb-4">{job.title}</h1>
            <div className="card shadow-sm">
                <div className="card-body">
                    <h5 className="card-title">{job.title}</h5>
                    <p className="card-text">
                        <strong>Company:</strong> {job.company} <br />
                        <strong>Location:</strong> {job.location} <br />
                        <strong>Description:</strong> {job.description}
                    </p>
                    <div>{formattedDescription}</div>
                    <a href={job.link} target="_blank" rel="noopener noreferrer" className="btn btn-success">
                        Apply Now
                    </a>
                </div>
            </div>
        </div>
    );
};

export default JobDetail;

